import { render, staticRenderFns } from "./RemoveStepButton.vue?vue&type=template&id=5e73c3cc&scoped=true&lang=pug"
import script from "./RemoveStepButton.vue?vue&type=script&lang=js"
export * from "./RemoveStepButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveStepButton.vue?vue&type=style&index=0&id=5e73c3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73c3cc",
  null
  
)

export default component.exports